import { ofType } from 'redux-observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, iif, debounceTime } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_TIMESHEET_CHART_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  storeTimesheetChartListAction,
} from '../../data.action';

const retrieveTimesheetChartListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_TIMESHEET_CHART_LIST),
    debounceTime(20),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_TIMESHEET_CHART_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ timesheetLoader: true })),
        iif(
          () => body?.pageSize <= 100,
          of(setListConfigAction({ timesheetChart: body })),
          EMPTY
        ),
        defer(() =>
          from(
            request({ path: `timesheet/chart`, method: httpMethods.POST, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return {
                total: p?.total,
                amount: p?.amount,
                result: p?.result,
              };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_TIMESHEET_CHART_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeTimesheetChartListAction(data))),
            catchError(err => {
              console.error(
                `[epic ${RETRIEVE_TIMESHEET_CHART_LIST}] error`,
                err
              );
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ timesheetLoader: false }))
      );
    })
  );

export default retrieveTimesheetChartListEpic;
